module.exports = __webpack_public_path__ + "img/Angiogenesis-GBM_10X_WTA.06470e6e.png";